<template>
  <div class="mb-4" style="background-color: var(--color-white)">
    <div class="row">
      <!-- Solar Panels -->
      <div class="col-12">
        <div
          class="mb-3"
          style="
            min-height: 64px;
            background-color: var(--color-light-light-gray);
            display: flex;
            align-items: flex-start;
            padding: 20px;
          "
        >
          <template v-if="selectedPanels.length > 0">
            <span style="white-space: nowrap; flex-shrink: 0; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); font-size: 20px;">{{ $t("project.previewAndReport.solarPanels.title") }}<span style="display: inline-block; width: 20px;"></span>|</span>
            <span style="flex: 1; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); padding-left: 20px; color: var(--description-color); font-size: 16px;">{{ panelsString }}</span>
          </template>
          <template v-else>
            <span style="white-space: nowrap; flex-shrink: 0; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); font-size: 20px;">{{ $t("project.previewAndReport.solarPanels.title") }}<span style="display: inline-block; width: 20px;"></span>|</span>
            <span style="padding-left: 20px; flex: 1; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); color: var(--description-color); font-size: 16px;">N/A</span>
          </template>
        </div>
      </div>

      <!-- Inverters -->
      <div class="col-12">
        <div
          class="mb-3"
          style="
            background-color: var(--color-light-light-gray);
            padding: 20px;
          "
        >
          <template v-if="selectedInverters.length > 0">
            <div style="display: flex; align-items: flex-start; min-height: 20px;">
              <span style="white-space: nowrap; flex-shrink: 0; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); font-size: 20px;">{{ $t("project.previewAndReport.inverters.title") }}<span style="display: inline-block; width: 20px;"></span>|</span>
              <span style="flex: 1; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); padding-left: 20px; color: var(--description-color); font-size: 16px;">{{ invertersString }}</span>
            </div>
            <div style="font-size: 12px; margin: 0; margin-top: 2px; color: var(--description-color);">{{ $t("project.previewAndReport.inverters.note") }}</div>
          </template>
          <template v-else>
            <div style="display: flex; align-items: flex-start; min-height: 32px;">
              <span style="white-space: nowrap; flex-shrink: 0; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); font-size: 20px;">{{ $t("project.previewAndReport.inverters.title") }}<span style="display: inline-block; width: 20px;"></span>|</span>
              <span style="padding-left: 20px; flex: 1; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); color: var(--description-color); font-size: 16px;">N/A</span>
            </div>
          </template>
        </div>
      </div>

      <!-- Batteries -->
      <div class="col-12">
        <div
          class="mb-3"
          style="
            min-height: 64px;
            background-color: var(--color-light-light-gray);
            display: flex;
            align-items: flex-start;
            padding: 20px;
          "
        >
          <template v-if="selectedBatteries.length > 0">
            <span style="white-space: nowrap; flex-shrink: 0; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); font-size: 20px;">{{ $t("project.previewAndReport.batteries.title") }}<span style="display: inline-block; width: 20px;"></span>|</span>
            <span style="flex: 1; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); padding-left: 20px; color: var(--description-color); font-size: 16px;">{{ batteriesString }}</span>
          </template>
          <template v-else>
            <span style="white-space: nowrap; flex-shrink: 0; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); font-size: 20px;">{{ $t("project.previewAndReport.batteries.title") }}<span style="display: inline-block; width: 20px;"></span>|</span>
            <span style="padding-left: 20px; flex: 1; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); color: var(--description-color); font-size: 16px;">N/A</span>
          </template>
        </div>
      </div>

      <!-- EV Chargers -->
      <div class="col-12">
        <div
          class="mb-3"
          style="
            min-height: 64px;
            background-color: var(--color-light-light-gray);
            display: flex;
            align-items: flex-start;
            padding: 20px;
          "
        >
          <template v-if="selectedEVChargers.length > 0">
            <span style="white-space: nowrap; flex-shrink: 0; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); font-size: 20px;">{{ $t("project.previewAndReport.evChargers.title") }}<span style="display: inline-block; width: 20px;"></span>|</span>
            <span style="flex: 1; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); padding-left: 20px; color: var(--description-color); font-size: 16px;">{{ evChargersString }}</span>
          </template>
          <template v-else>
            <span style="white-space: nowrap; flex-shrink: 0; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); font-size: 20px;">{{ $t("project.previewAndReport.evChargers.title") }}<span style="display: inline-block; width: 20px;"></span>|</span>
            <span style="padding-left: 20px; flex: 1; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); color: var(--description-color); font-size: 16px;">N/A</span>
          </template>
        </div>
      </div>

      <!-- Meters -->
      <div class="col-12">
        <div
          class="mb-3"
          style="
            min-height: 64px;
            background-color: var(--color-light-light-gray);
            display: flex;
            align-items: flex-start;
            padding: 20px;
          "
        >
          <template v-if="selectedMeters.length > 0">
            <span style="white-space: nowrap; flex-shrink: 0; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); font-size: 20px;">{{ $t("project.previewAndReport.meters.title") }}<span style="display: inline-block; width: 20px;"></span>|</span>
            <span style="flex: 1; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); padding-left: 20px; color: var(--description-color); font-size: 16px;">{{ metersString }}</span>
          </template>
          <template v-else>
            <span style="white-space: nowrap; flex-shrink: 0; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); font-size: 20px;">{{ $t("project.previewAndReport.meters.title") }}<span style="display: inline-block; width: 20px;"></span>|</span>
            <span style="padding-left: 20px; flex: 1; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); color: var(--description-color); font-size: 16px;">N/A</span>
          </template>
        </div>
      </div>

      <!-- Connections -->
      <div class="col-12" v-if="shouldShowConnections">
        <div
          class="mb-3"
          style="
            background-color: var(--color-light-light-gray);
            padding: 20px;
          "
        >
          <div style="display: flex; align-items: flex-start; min-height: 20px;">
            <span style="white-space: nowrap; flex-shrink: 0; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); font-size: 20px;">{{ $t("project.previewAndReport.connections.title") }}<span style="display: inline-block; width: 20px;"></span>|</span>
            <span style="flex: 1; line-height: 1.2; margin-top: calc((1.2 * 12px - 1.2em) / 2); padding-left: 20px; color: var(--description-color); font-size: 16px;">
              {{ $t("project.previewAndReport.connections.description") }}
            </span>
          </div>
          <div v-if="shouldShowDisclaimer" style="font-size: 12px; margin: 0; margin-top: 2px; color: var(--description-color);" v-html="$t('project.previewAndReport.connections.disclaimer')"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ComputedRef, computed } from "vue";
import type { Panel, Inverter, Battery, EVCharger, Meter } from "@/types/projectTypes";

export default defineComponent({
  name: "PlantComponentsSection",
  props: {
    reportType: {
      type: String,
      required: true,
    },
    selectedMeters: {
      type: Array as PropType<Meter[]>,
      required: true,
      default: () => [],
    },
    selectedPanels: {
      type: Array as PropType<Panel[]>,
      required: true,
      default: () => [],
    },
    selectedInverters: {
      type: Array as PropType<Inverter[]>,
      required: true,
      default: () => [],
    },
    selectedBatteries: {
      type: Array as PropType<Battery[]>,
      required: true,
      default: () => [],
    },
    selectedEVChargers: {
      type: Array as PropType<EVCharger[]>,
      required: true,
      default: () => [],
    },
    getPanelDeviceCount: {
      type: Function as PropType<(id: number) => ComputedRef<number>>,
      required: true,
    },
    getInverterDeviceCount: {
      type: Function as PropType<(id: number) => ComputedRef<number>>,
      required: true,
    },
    getBatteryDeviceCount: {
      type: Function as PropType<(id: number) => ComputedRef<number>>,
      required: true,
    },
    getEVChargerDeviceCount: {
      type: Function as PropType<(id: number) => ComputedRef<number>>,
      required: true,
    },
    getMeterDeviceCount: {
      type: Function as PropType<(id: number) => ComputedRef<number>>,
      required: true,
    },
  },
  setup(props) {
    const shouldShowConnections = computed(() => {
      return props.reportType === 'complete_solution.one_time' || props.reportType === 'complete_solution.installment';
    });

    const shouldShowDisclaimer = computed(() => {
      return props.reportType === 'complete_solution.one_time' || props.reportType === 'complete_solution.installment';
    });

    const panelsString = computed(() => {
      return props.selectedPanels
        .map(panel => `${panel.manufacturer} - ${panel.model_number} n° ${props.getPanelDeviceCount(panel.id).value}`)
        .join(', ');
    });

    const invertersString = computed(() => {
      return props.selectedInverters
        .map(inverter => `${inverter.manufacturer} - ${inverter.model_number} n° ${props.getInverterDeviceCount(inverter.id).value}`)
        .join(', ');
    });

    const batteriesString = computed(() => {
      return props.selectedBatteries
        .map(battery => `${battery.manufacturer} - ${battery.model_number} n° ${props.getBatteryDeviceCount(battery.id).value}`)
        .join(', ');
    });

    const evChargersString = computed(() => {
      return props.selectedEVChargers
        .map(charger => `${charger.manufacturer} - ${charger.model_number} n° ${props.getEVChargerDeviceCount(charger.id).value}`)
        .join(', ');
    });

    const metersString = computed(() => {
      return props.selectedMeters
        .map(meter => `${meter.manufacturer} - ${meter.model_number} n° ${props.getMeterDeviceCount(meter.id).value}`)
        .join(', ');
    });

    return {
      shouldShowConnections,
      shouldShowDisclaimer,
      panelsString,
      invertersString,
      batteriesString,
      evChargersString,
      metersString,
    };
  },
});
</script>
